// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationListMetaQuery
 */
export interface AutomationListMetaQuery {
    /**
     * Room filter (echoed from request)
     */
    room?: string | null;
    /**
     * Device filter (echoed from request)
     */
    device?: Array<string>;
}

/**
 * Check if a given object implements the AutomationListMetaQuery interface.
 */
export function instanceOfAutomationListMetaQuery(value: object): value is AutomationListMetaQuery {
    return true;
}

export function AutomationListMetaQueryFromJSON(json: any): AutomationListMetaQuery {
    return AutomationListMetaQueryFromJSONTyped(json, false);
}

export function AutomationListMetaQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationListMetaQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'room': json['room'] === undefined ? undefined : json['room'] === null ? null : json['room'],
        'device': json['device'] == null ? undefined : json['device'],
    };
}

export function AutomationListMetaQueryToJSON(json: any): AutomationListMetaQuery {
    return AutomationListMetaQueryToJSONTyped(json, false);
}

export function AutomationListMetaQueryToJSONTyped(value?: AutomationListMetaQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'room': value['room'],
        'device': value['device'],
    };
}

